<template>
  <div class="login-page">
    <login-card></login-card>
  </div>
</template>

<script>
import LoginCard from './components/LoginCard';

export default {
  components: { LoginCard },
  metaInfo() {
    return {
      title: this.$t('login.titleLogin'),
      titleTemplate: '%s | Nukli',
    };
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 64px del AppBar fijo + aire (v-main no lo compensa) */
  padding: 96px 16px 32px;
  background: var(--lp-bg);
}
</style>
